"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var UserMessage = function UserMessage(_ref) {
  var content = _ref.content;
  return (0, _preact.h)("div", {
    className: "forethought-agent__turn forethought-agent__turn--user"
  }, (0, _preact.h)("div", {
    className: "forethought-agent__bubble forethought-agent__bubble--user"
  }, content));
};

var _default = UserMessage;
exports.default = _default;